// import Profile from '@/views/profile/Profile'
const Profile = () => import('@/views/profile/Profile')

import getWhiteLabel from '@/utils/getWhiteLabel';

import Index from '@/views/Index.vue';

const profileRouter = {
    path: '/settings',
    component: Index,
    name: 'settings',
    meta: {
        requiresAuth: true
    },
    children: [{
        name: 'client/settings',
        path: '/',
        component: Profile,
        meta: {
            title: `${getWhiteLabel()} - Minha Conta`,
            requiresAuth: true
        },
    }, ]

}

export default profileRouter;